import { cn } from "@omni/utils/styles";

import { AutocompleteItem } from "@/components/Search/SearchBar/AutocompleteItem/autocompleteItem.container";
import { BaseItemProps } from "@/components/Search/SearchBar/ResultsPanel/resultsPanel.templates";
import { ContentPagesSourceType } from "@/components/Search/SearchBar/searchBar.types";

type ContentPagesItemProps = BaseItemProps<ContentPagesSourceType>;

const ContentPagesItem = ({
    item,
    autocompleteState,
    autocompleteActions
}: ContentPagesItemProps) => (
    <AutocompleteItem<ContentPagesSourceType>
        itemId={item.__autocomplete_id}
        href={item.externalPath}
        className={cn(
            "tw:rounded-sm tw:no-underline tw:flex tw:items-center tw:min-w-0"
        )}
        autocompleteState={autocompleteState}
        autocompleteActions={autocompleteActions}
    >
        <i className={cn("las la-arrow-right", "tw:pr-2")}></i>
        <span
            className={cn(
                "tw:whitespace-nowrap tw:overflow-hidden tw:text-ellipsis"
            )}
        >
            {item.title}
        </span>
    </AutocompleteItem>
);

export { ContentPagesItem };
